package com.htmlagent.site.i18n

/**
 * The readable name of a section id the generated list does not cover.
 *
 * The agent names its own sections, so the list can never be complete: an unknown id is turned
 * into something readable rather than shown raw or hidden.
 */
internal fun humanizeSectionId(id: String): String =
    id.replace('-', ' ').replaceFirstChar { it.uppercase() }
